module.exports = __webpack_public_path__ + "img/entryway-rugs-runners.1494ced.jpg";